export const MESSAGE_MIN_LENGTH = 200;
export const MESSAGE_MAX_LENGTH = 10000;
